import * as React from 'react';
import './simpleEntranceFeeView.module.scss';

export const SimpleEntranceFeeView = ({ price, price_with_tax }) => (
  <>
    <div styleName="plus">+</div>
    <div styleName="entrance-fee">
      <span styleName="label">入会金</span>
      <span styleName="price">
        <span styleName="price-no">{price.toLocaleString()}</span>円
        <span>（税込 {price_with_tax.toLocaleString()}円）</span>
      </span>
    </div>
  </>
);
